export default __webpack_public_path__ + "static/media/our_department.a434cdbe.mp4";